module.exports = __webpack_public_path__ + "img/fb.f7b7a9e9.svg";